(() => {
function upgradeThumbnailSources(productSingle) {
      if (!productSingle) return;
      const widths = [120, 240, 360];
      productSingle.querySelectorAll('.media-gallery__thumb-image').forEach((thumbnail) => {
        const existingSources = thumbnail.getAttribute('srcset') || '';
        const largestSource = existingSources.split(',').at(-1)?.trim().split(/\s+/)[0] || thumbnail.src;
        const sourceUrl = new URL(largestSource, document.baseURI);
        const sourceWidth = Number(sourceUrl.searchParams.get('width')) || thumbnail.naturalWidth || 1;
        const sourceHeight = Number(sourceUrl.searchParams.get('height')) || thumbnail.naturalHeight || sourceWidth;
        const aspectRatio = sourceHeight / sourceWidth;
        const upgradedSources = widths.map((width) => {
          const candidateUrl = new URL(sourceUrl);
          candidateUrl.searchParams.set('width', String(width));
          candidateUrl.searchParams.set('height', String(Math.round(width * aspectRatio)));
          return `${candidateUrl.toString()} ${width}w`;
        });
        thumbnail.setAttribute('srcset', upgradedSources.join(', '));
        thumbnail.setAttribute('sizes', '120px');
      });
    }

    function initializePurchaseOptions() {
      const roots = [...document.querySelectorAll('[data-ka-sunset-denny-purchase]')];
      roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const variantsNode = root.querySelector('[data-denny-variants-json]');
      const variants = JSON.parse(variantsNode?.textContent || '[]');

      const section = root.closest('[id^="shopify-section-"]') || document;
      const productRegion = root.closest('.product-single__box, product-single, [data-section-type*="product"], product-info, .product') || section;
      productRegion?.setAttribute?.('data-denny-product-region', '');
      const productSingle = root.closest('product-single') || section.querySelector?.('product-single');
      if (productSingle) productSingle.setAttribute('data-denny-product-single', '');
      upgradeThumbnailSources(productSingle);
      const productSection = productSingle?.closest('.section--product-single');
      if (productSection) productSection.setAttribute('data-denny-product-section', '');
      const form = productRegion.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      const nativeVariantInput = () => form?.querySelector('[name="id"]');
      const productSectionId = form?.getAttribute('id')?.replace(/^product-form-/, '');
      const messageToggle = root.querySelector('[data-denny-message-toggle]');
      const messageFields = root.querySelector('[data-denny-message-fields]');
      const wrapping = root.querySelector('[data-denny-wrapping]');
      const noshi = root.querySelector('[data-denny-noshi]');
      const noshiFields = root.querySelector('[data-denny-noshi-fields]');
      const noshiContent = root.querySelector('[data-denny-noshi-content]');
      const errorOutput = root.querySelector('[data-denny-gift-error]');
      const sizeOutput = root.querySelector('[data-denny-size]');
      const frameOutput = root.querySelector('[data-denny-frame]');
      const wrappingOutput = root.querySelector('[data-denny-wrapping-summary]');
      const noshiOutput = root.querySelector('[data-denny-noshi-summary]');
      const priceOutput = root.querySelector('[data-denny-price]');
      const pointsOutput = root.querySelector('[data-denny-points-value]');
      const pointsContainer = root.querySelector('[data-denny-points]');
      const pointsRatePercent = Number(pointsContainer?.dataset.poingpongRatePercent || 0);
      const shippingRoot = root.parentElement?.querySelector('[data-ka-sunset-denny-shipping]')
        || document.querySelector('[data-ka-sunset-denny-shipping]');
      const dispatchOutput = shippingRoot?.querySelector('[data-denny-dispatch]');
      const buyBlock = productRegion.querySelector('.product-single__box__block--buy_buttons');
      if (shippingRoot && buyBlock && buyBlock.nextElementSibling !== shippingRoot) {
        buyBlock.after(shippingRoot);
      }
      const approvedFrames = ['オークカラー', 'ホワイト（木目調）', 'ブラウン（木目調）', 'ホワイト(木目調)', 'ブラウン(木目調)', 'パールホワイト'];

      function selectedVariant() {
        return variants.find((variant) => String(variant.id) === String(nativeVariantInput()?.value));
      }

      function displayFrame(value) {
        const normalized = String(value || '').replace(/額$/, '');
        if (normalized === 'オーク' || normalized === 'Oak') return 'オークカラー';
        if (normalized === '白') return 'ホワイト（木目調）';
        if (normalized === 'ブラウン' || normalized === 'Brown') return 'ブラウン（木目調）';
        return normalized;
      }

      function displayNoshi(value) {
        return String(value || '熨斗なし').replace(/熨斗/g, 'のし');
      }

      function nativeFrameRadios() {
        return [...(productRegion.querySelectorAll?.('input[type="radio"][name="額縁"]') || [])];
      }

      function decorateNativeVariantPicker() {
        const frameHeading = nativeFrameRadios()[0]?.closest?.('fieldset')?.querySelector?.('legend');
        if (frameHeading) frameHeading.textContent = '額縁の種類';
        nativeFrameRadios().forEach((radio) => {
          const item = radio.closest?.('.product-form__swatch__item');
          const label = item?.querySelector?.(`label[for="${radio.id}"]`);
          const approved = approvedFrames.includes(displayFrame(radio.value));
          if (item) item.hidden = !approved;
          radio.disabled = !approved;
          if (radio.value === '白') {
            if (item) item.title = 'ホワイト（木目調）';
            if (label) label.textContent = 'ホワイト（木目調）';
          }
          if (radio.value === 'オーク') {
            if (item) item.title = 'オークカラー';
            if (label) label.textContent = 'オークカラー';
          }
          if (radio.value === 'ブラウン') {
            if (item) item.title = 'ブラウン（木目調）';
            if (label) label.textContent = 'ブラウン（木目調）';
          }
        });
      }

      function formatMoney(cents) {
        if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
        return new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: 'JPY',
          maximumFractionDigits: 0,
        }).format(Number(cents || 0) / 100);
      }

      function quantityInput() {
        return form?.querySelector('[name="quantity"]') || productRegion.querySelector('[name="quantity"]');
      }

      function selectedQuantity() {
        return Math.max(1, Number(quantityInput()?.value || 1));
      }

      function syncMessageFields() {
        const messageEnabled = Boolean(messageToggle?.checked);
        if (messageFields) messageFields.hidden = !messageEnabled;
        messageFields?.querySelectorAll('input, textarea, select').forEach((control) => {
          control.disabled = !messageEnabled;
        });
        if (dispatchOutput) {
          dispatchOutput.textContent = messageEnabled ? "注文受付後1〜3営業日で発送（レイアウト確認後1〜2営業日で発送） ※レイアウトへのOKのお返事をいただいてから発送します。ご返信の時期や修正内容によっては、上記の目安より日数がかかる場合があります。" : '1〜2営業日で発送';
        }
      }

      function syncNoshiFields() {
        const enabled = Boolean(noshi && noshi.value !== '熨斗なし');
        if (noshiFields) noshiFields.hidden = !enabled;
        if (noshiContent) noshiContent.disabled = !enabled;
      }

      function syncPurchaseSummary() {
        decorateNativeVariantPicker();
        const variant = selectedVariant();
        if (variant) {
          if (sizeOutput) sizeOutput.textContent = variant.option1 || '';
          if (frameOutput) frameOutput.textContent = displayFrame(variant.option2);
        }
        if (wrappingOutput) wrappingOutput.textContent = wrapping?.value || 'ラッピングなし';
        if (noshiOutput) noshiOutput.textContent = displayNoshi(noshi?.value);
        const quantity = selectedQuantity();
        const variantPrice = Number(variant?.price || 0);
        const wrappingFee = Number(wrapping?.selectedOptions?.[0]?.dataset.feePrice || 0);
        const noshiFee = Number(noshi?.selectedOptions?.[0]?.dataset.noshiFeePrice || 0);
        const totalCents = quantity * (variantPrice + wrappingFee + noshiFee);
        if (priceOutput) priceOutput.textContent = formatMoney(totalCents);
        if (pointsOutput && Number.isFinite(pointsRatePercent)) {
          pointsOutput.textContent = Math.floor((totalCents * pointsRatePercent) / 10000);
        }
      }

      function messageProperties() {
        const properties = {};
        if (!messageToggle?.checked || !messageFields) return properties;
        messageFields.querySelectorAll('[name^="properties["]').forEach((control) => {
          const key = control.name.match(/^properties\[(.+)\]$/)?.[1];
          const value = control.value.trim();
          if (key && value) properties[key] = value;
        });
        return properties;
      }

      function collectGiftItems(token) {
        const variantInput = nativeVariantInput();
        if (!form || !variantInput) return [];
        const selectedWrapping = wrapping?.selectedOptions?.[0];
        const selectedNoshi = noshi?.selectedOptions?.[0];
        const wrappingFeeVariantId = selectedWrapping?.dataset.feeVariantId;
        const noshiFeeVariantId = selectedNoshi?.dataset.noshiFeeVariantId;
        const quantity = Math.max(1, Number(quantityInput()?.value || 1));
        const properties = {
          ...messageProperties(),
          'ラッピング': wrapping?.value || 'ラッピングなし',
          'のし': displayNoshi(noshi?.value),
        };
        const purposeSelect = document.querySelector('[data-denny-purpose]');
        if (purposeSelect && purposeSelect.value) properties['ご利用用途'] = purposeSelect.value;

        if (noshi?.value !== '熨斗なし') {
          properties['のしの記載内容'] = noshiContent?.value.trim() || '';
        }
        if (wrappingFeeVariantId || noshiFeeVariantId) {
          properties._dn13_gift_token = token;
          properties._dn13_gift_role = 'main';
        }

        const items = [{ id: Number(variantInput.value), quantity, properties }];
        if (wrappingFeeVariantId) {
          items.push({
            id: Number(wrappingFeeVariantId),
            quantity,
            properties: {
              _dn13_gift_token: token,
              _dn13_gift_role: 'fee',
              _dn13_gift_fee_type: 'wrapping',
            },
          });
        }
        if (noshiFeeVariantId) {
          items.push({
            id: Number(noshiFeeVariantId),
            quantity,
            properties: {
              _dn13_gift_token: token,
              _dn13_gift_role: 'fee',
              _dn13_gift_fee_type: 'art-noshi',
            },
          });
        }
        return items;
      }

      async function submitPurchase(event) {
        if (event.target !== form) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        if (noshi?.value !== '熨斗なし' && !noshiContent?.value.trim()) {
          if (errorOutput) {
            errorOutput.hidden = false;
            errorOutput.textContent = 'のしの記載内容をご入力ください。';
          }
          noshiContent?.focus();
          return;
        }

        if (errorOutput) errorOutput.hidden = true;
        const addButton = form.querySelector('[name="add"], button[type="submit"]');
        if (addButton) addButton.disabled = true;
        const token = window.crypto?.randomUUID?.() || `dn13-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const items = collectGiftItems(token);
        const rootPath = window.Shopify?.routes?.root || '/';

        try {
          const response = await fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error('cart add failed');
          window.location.assign(rootPath + 'cart');
        } catch (error) {
          if (addButton) addButton.disabled = false;
          if (errorOutput) {
            errorOutput.hidden = false;
            errorOutput.textContent = 'カートに追加できませんでした。時間をおいて、もう一度お試しください。';
          }
        }
      }

      messageToggle?.addEventListener('change', () => {
        syncMessageFields();
        syncPurchaseSummary();
      });
      wrapping?.addEventListener('change', syncPurchaseSummary);
      noshi?.addEventListener('change', () => {
        syncNoshiFields();
        syncPurchaseSummary();
      });
      productRegion.addEventListener('change', () => requestAnimationFrame(syncPurchaseSummary));
      productRegion.addEventListener('click', (event) => {
        if (!event.target.closest?.('.product-single__box__block--quantity_selector')) return;
        requestAnimationFrame(syncPurchaseSummary);
      });
      document.addEventListener('variant:changed', (event) => {
        if (event.detail?.sectionId && productSectionId && event.detail.sectionId !== productSectionId) return;
        syncPurchaseSummary();
      });
      form?.addEventListener('submit', submitPurchase, true);
      // 9/23：カートに追加→カート画面→「戻る」で、Safari が前の画面をそのまま復元すると、通信中に押せなくしたボタンが押せないまま残る。
      // 復元されたときは、売り切れ等でテーマが押せなくしている場合（.js-product-buttons に is-disabled）を除き、押せる状態に戻す。
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted || !form) return;
        const addButton = form.querySelector('[name="add"], button[type="submit"]');
        if (addButton?.disabled && !form.querySelector('.js-product-buttons.is-disabled')) addButton.disabled = false;
      });
      const quantityControl = quantityInput();
      quantityControl?.addEventListener('change', syncPurchaseSummary);
      quantityControl?.addEventListener('input', syncPurchaseSummary);
      const initialVariantInput = nativeVariantInput();
      if (initialVariantInput) {
        initialVariantInput.addEventListener('change', syncPurchaseSummary);
        new MutationObserver(syncPurchaseSummary).observe(initialVariantInput, {
          attributes: true,
          attributeFilter: ['value'],
        });
      }

      syncMessageFields();
      syncNoshiFields();
      syncPurchaseSummary();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePurchaseOptions, { once: true });
    } else {
      initializePurchaseOptions();
    }
  })();

(() => {
    const guideSelector = '[data-ka-sunset-denny-guide]';
    const guideRoots = (context) => [
      ...(context.matches?.(guideSelector) ? [context] : []),
      ...context.querySelectorAll(guideSelector),
    ];
    const guideCleanups = new WeakMap();
    const relatedOwners = new WeakMap();

    const initDn13Guide = (root) => {
      if (!root || root.dataset.guideReady === 'true') return;
      root.dataset.guideReady = 'true';
      let frameOpener = null;
      let frameScrollPosition = { x: 0, y: 0 };

      (root.querySelectorAll?.('[data-denny-frame-open]') || []).forEach((opener) => {
        const dialogId = opener.getAttribute('data-denny-frame-open');
        const dialog = dialogId ? root.querySelector(`#${dialogId}`) : null;
        if (!dialog) return;
        opener.addEventListener('click', () => {
          frameOpener = opener;
          frameScrollPosition = { x: window.scrollX, y: window.scrollY };
          dialog.showModal();
        });
      });
      (root.querySelectorAll?.('[data-denny-frame-dialog]') || []).forEach((dialog) => {
        dialog.querySelector('[data-denny-frame-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => {
          frameOpener?.focus({ preventScroll: true });
          window.scrollTo({ left: frameScrollPosition.x, top: frameScrollPosition.y, behavior: 'auto' });
          frameOpener = null;
        });
      });

      (root.querySelectorAll?.('.ka-sunset-denny-guide__spec-toggle') || []).forEach((toggle) => {
        const panelId = toggle.getAttribute('aria-controls');
        const panel = panelId ? root.querySelector(`#${panelId}`) : null;
        if (!panel) return;
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          panel.hidden = expanded;
          const symbol = toggle.querySelector('[aria-hidden="true"]');
          if (symbol) symbol.textContent = expanded ? '＋' : '−';
        });
      });

      const guideSection = root.closest?.('.shopify-section');
      let relatedSection = null;
      const syncRelatedSection = () => {
        const liveRelatedSection = guideSection?.parentElement?.querySelector?.('.js-section__product-recommendations') || null;
        if (relatedSection && relatedSection !== liveRelatedSection && relatedOwners.get(relatedSection) === root) {
          relatedSection.removeAttribute('data-denny-related-products');
          relatedOwners.delete(relatedSection);
        }
        if (!liveRelatedSection?.matches?.('.shopify-section')) {
          relatedSection = null;
          return;
        }
        relatedSection = liveRelatedSection;
        relatedSection.setAttribute('data-denny-related-products', '');
        relatedOwners.set(relatedSection, root);
        const normalizeRelatedImageUrl = (value) => value?.replace(/([?&])crop=center&?/g, '$1').replace('?&', '?').replace(/&&+/g, '&');
        relatedSection.querySelectorAll?.('.product-card__img').forEach((image) => {
          const source = image.getAttribute('src');
          const sourceSet = image.getAttribute('srcset');
          if (source?.includes('crop=center')) image.setAttribute('src', normalizeRelatedImageUrl(source));
          if (sourceSet?.includes('crop=center')) image.setAttribute('srcset', normalizeRelatedImageUrl(sourceSet));
        });
      };
      syncRelatedSection();
      const relatedObserver = typeof MutationObserver === 'function' && guideSection?.parentElement
        ? new MutationObserver(syncRelatedSection)
        : null;
      relatedObserver?.observe(guideSection.parentElement, { childList: true, subtree: true });


      guideCleanups.set(root, () => {
        relatedObserver?.disconnect();
        if (relatedSection && relatedOwners.get(relatedSection) === root) {
          relatedSection.removeAttribute('data-denny-related-products');
          relatedOwners.delete(relatedSection);
        }
        guideCleanups.delete(root);
      });
    };

    guideRoots(document).forEach(initDn13Guide);
    if (window.kaSunsetDn13GuideSectionLoadBound !== true) {
      window.kaSunsetDn13GuideSectionLoadBound = true;
      document.addEventListener('shopify:section:load', (event) => {
        guideRoots(event.target).forEach(initDn13Guide);
      });
      document.addEventListener('shopify:section:unload', (event) => {
        guideRoots(event.target).forEach((root) => guideCleanups.get(root)?.());
      });
    }
  })();
